import type { ISyllabusTab } from '../types'
export const SYLLABUS_TABS: ISyllabusTab[] = [
	{
		id: 'course-overview',
		index: 0,
		name: 'Course overview',
	},
	{
		id: 'rationale',
		index: 1,
		name: 'Rationale',
	},
	{
		id: 'aim',
		index: 2,
		name: 'Aim',
	},
	{
		id: 'outcomes',
		index: 3,
		name: 'Outcomes',
	},
	{
		id: 'content',
		index: 4,
		name: 'Content',
	},
	{
		id: 'assessment',
		index: 5,
		name: 'Assessment',
	},
	{
		id: 'glossary',
		index: 6,
		name: 'Glossary',
	},
	{
		id: 'teaching-and-learning',
		index: 7,
		name: 'Teaching and learning support',
	},
]
